import { IconLock } from '@tabler/icons-react';
import { PageHead } from './layout/PageHead';
import { EmptyState } from './ui';

/**
 * [ADR-069 §9 regra 5 / F4.3 #890] Tela cheia mostrada quando o usuário acessa por URL
 * direta uma rota pra qual não tem a permissão RBAC mapeada em `nav-config.ts`. Reusa o
 * `EmptyState` (componente já existente do design system) — não havia um "Acesso negado"
 * dedicado, então este é o ponto único: qualquer ajuste visual futuro conserta em um lugar
 * só, em vez de replicar `<PageHead subtitle="Acesso negado.">` por página.
 *
 * Não redireciona — fica na própria rota (sem loop, sem histórico extra).
 *
 * [ADR-069 §7/§13.15 F2 #925 #891, 2026-09-29] Mensagem padrão ÚNICA pra toda checagem de
 * acesso convertida de papel fixo (`usuario.perfil`) pra `usePermissao`/guarda de rota —
 * nunca cita papéis (ADMIN_TENANT/GESTOR/...) nem código de permissão, de propósito: o texto
 * não muda por tela, e não vaza detalhe de RBAC pra quem não tem acesso.
 */
export function AcessoNegado(): JSX.Element {
  return (
    <>
      <PageHead title="Acesso restrito" />
      <EmptyState
        icon={<IconLock size={28} />}
        title="Acesso restrito"
        description="Você não tem permissão para acessar esta tela. Fale com o administrador da sua empresa."
      />
    </>
  );
}
